import AboutModal from '@/epos/vue/modals/About/AboutModal';
import AddGoCardlessBankAccountModal from '@/epos/vue/modals/AddGoCardlessBankAccount/AddGoCardlessBankAccountModal';
import AddressModal from '@/epos/vue/modals/Address/AddressModal';
import AdjustFloatModal from '@/epos/vue/modals/AdjustFloat/AdjustFloatModal';
import CartFieldsModal from '@/epos/vue/modals/CartFields/CartFieldsModal';
import CartLineDetailsModal from '@/epos/vue/modals/CartLineDetails/CartLineDetailsModal';
import CartOffersModal from '@/epos/vue/modals/CartOffers/CartOffersModal';
import CartPreviewModalSheet from '@/epos/vue/modals/CartPreview/CartPreviewModalSheet';
import CashUpConfirmModal from '@/epos/vue/modals/CashUpConfirm/CashUpConfirmModal';
import CashUpModal from '@/epos/vue/modals/CashUp/CashUpModal';
import ChangeModal from '@/epos/vue/modals/Change/ChangeModal';
import CloverTerminalsModal from '@/epos/vue/modals/CloverTerminals/CloverTerminalsModal';
import CompleteWaiverModal from '@/epos/vue/modals/CompleteWaiver/CompleteWaiverModal';
import CustomerDetailsModal from '@/epos/vue/modals/CustomerDetails/CustomerDetailsModal';
import CustomerMarketingPreferencesModal from '@/epos/vue/modals/CustomerMarketingPreferences/CustomerMarketingPreferencesModal';
import DebugModal from '@/epos/vue/modals/Debug/DebugModal';
import DojoTerminalsModal from '@/epos/vue/modals/DojoTermimals/DojoTerminalsModal';
import EposAppRoot from '@/epos/vue/components/EposAppRoot';
import EposMenuModal from '@/epos/vue/modals/EposMenu/EposMenuModal';
import GiftAidModal from '@/epos/vue/modals/GiftAid/GiftAidModal';
import GroupBookingReferenceModal from '@/epos/vue/modals/GroupBookings/GroupBookingReferenceModal';
import HeldCartsModal from '@/epos/vue/modals/HeldCarts/HeldCartsModal';
import HoldCartModal from '@/epos/vue/modals/HoldCart/HoldCartModal';
import KitchenOrdersModal from '@/epos/vue/modals/KitchenOrders/KitchenOrdersModal';
import ManageGoCardlessModal from '@/epos/vue/modals/ManageGoCardless/ManageGoCardlessModal';
import MellonWebECRApiKeysModal from '@/epos/vue/modals/Payment/PaymentMethods/MellonWebECR/MellonWebECRApiKeysModal';
import MellonWebECRRecoveryModal from '@/epos/vue/modals/Payment/PaymentMethods/MellonWebECR/MellonWebECRRecoveryModal';
import MellonWebECRRedeemModal from '@/epos/vue/modals/Payment/PaymentMethods/MellonWebECR/MellonWebECRRedeemModal';
import MellonWebECRTransactionsModal from '@/epos/vue/modals/Payment/PaymentMethods/MellonWebECR/MellonWebECRTransactionsModal';
import MembersConfirmModal from '@/epos/vue/modals/MembersConfirm/MembersConfirmModal';
import MembershipCancellationModal from '@/epos/vue/modals/MembershipCancellation/MembershipCancellationModal';
import MembershipInstallmentsModal from '@/epos/vue/modals/MembershipInstallments/MembershipInstallmentsModal';
import MembershipRenewalDateModal from '@/epos/vue/modals/MembershipRenewalDate/MembershipRenewalDateModal';
import MergeCartModal from '@/epos/vue/modals/MergeCart/MergeCartModal';
import NewOrderWaiversModal from '@/epos/vue/modals/NewOrderWaivers/NewOrderWaiversModal';
import OrderEmailReceiptModal from '@/epos/vue/modals/OrderEmailReceipt/OrderEmailReceiptModal';
import OrderErrorModal from '@/epos/vue/modals/OrderError/OrderErrorModal';
import OrderNotesModal from '@/epos/vue/modals/OrderNotes/OrderNotesModal';
import OrderOutstandingBalanceModal from '@/epos/vue/modals/OrderPayments/OrderOutstandingBalanceModal';
import OrderPaymentDetailsModal from '@/epos/vue/modals/OrderPaymentDetails/OrderPaymentDetailsModal';
import OrderPaymentsModal from '@/epos/vue/modals/OrderPayments/OrderPaymentsModal';
import OrderPreviewModal from '@/epos/vue/modals/OrderPreview/OrderPreviewModal';
import PartialPaymentModal from '@/epos/vue/modals/PartialPayment/PartialPaymentModal';
import PaymentErrorModal from '@/epos/vue/modals/PaymentError/PaymentErrorModal';
import PaymentTokenSelectionModal from '@/epos/vue/modals/PaymentTokenSelection/PaymentTokenSelectionModal';
import PayyoConfigureTipsModal from '@/epos/vue/modals/Settings/PayyoConfigureTipsModal';
import PayyoManualReconciliationModal from '@/epos/vue/modals/Payment/PaymentMethods/Payyo/PayyoManualReconciliationModal';
import PayyoPaymentDetailsModal from '@/epos/vue/modals/Payment/PaymentMethods/Payyo/PayyoPaymentDetailsModal';
import PayyoTerminalRegistrationModal from '@/epos/vue/modals/Settings/PayyoTerminalRegistrationModal';
import PayyoTerminalsModal from '@/epos/vue/modals/Settings/PayyoTerminalsModal';
import PriceEditModal from '@/epos/vue/modals/PriceEdit/PriceEditModal';
import RefundablePaymentsModal from '@/epos/vue/modals/RefundablePayments/RefundablePaymentsModal';
import SearchModal from '@/epos/vue/modals/Search/SearchModal';
import SendToKitchenModal from '@/epos/vue/modals/SendToKitchen/SendToKitchenModal';
import SessionPickerModal from '@/epos/vue/modals/SessionPicker/SessionPickerModal';
import SettingsModal from '@/epos/vue/modals/Settings/SettingsModal';
import SimulatePayyoPaymentModal from '@/epos/vue/modals/Payment/PaymentMethods/Payyo/SimulatePayyoPaymentModal';
import SoldGiftVoucherDataModal from '@/epos/vue/modals/SoldGiftVoucherData/SoldGiftVoucherDataModal';
import SplitPaymentModal from '@/epos/vue/modals/SplitPayment/SplitPaymentModal';
import TablePicker from '@/epos/vue/modals/TablePicker/TablePicker';
import TicketPickerModal from '@/epos/vue/modals/TicketPicker/TicketPickerModal';
import TodayViewFiltersModalSheet from '@/epos/vue/modals/TodayViewFilters/TodayViewFiltersModalSheet';
import TradingSessionsListModal from '@/epos/vue/modals/TradingSessionsList/TradingSessionsListModal';
import VariableDiscountModal from '@/epos/vue/modals/VariableDiscount/VariableDiscountModal';
import WaiverCodeModal from '@/epos/vue/modals/WaiverCode/WaiverCodeModal';
import { createRouter, createWebHashHistory } from 'vue-router';
import { createVueApp, rootVueAppOptions } from '@/vue/main';
import { eposStore } from './stores/eposStore';
import { MODAL_NAMES__EPOS } from '@/epos/vue/modals/MODAL_NAMES__EPOS';
import { registerGlobalModals } from '@/vue/modals';

// Create the epos app root component.
const vueApp = createVueApp(EposAppRoot, eposStore, rootVueAppOptions());

registerGlobalModals(vueApp);

// Register global components that are only for the epos app.
vueApp.component(MODAL_NAMES__EPOS.ABOUT, AboutModal);
vueApp.component(MODAL_NAMES__EPOS.ADDRESS, AddressModal);
vueApp.component(MODAL_NAMES__EPOS.ADJUST_FLOAT, AdjustFloatModal);
vueApp.component(MODAL_NAMES__EPOS.ADD_GOCARDLESS_BANK_ACCOUNT, AddGoCardlessBankAccountModal);
vueApp.component(MODAL_NAMES__EPOS.CART_FIELDS, CartFieldsModal);
vueApp.component(MODAL_NAMES__EPOS.CART_LINE_DETAILS, CartLineDetailsModal);
vueApp.component(MODAL_NAMES__EPOS.CART_OFFERS, CartOffersModal);
vueApp.component(MODAL_NAMES__EPOS.CART_PREVIEW, CartPreviewModalSheet);
vueApp.component(MODAL_NAMES__EPOS.CASH_UP, CashUpModal);
vueApp.component(MODAL_NAMES__EPOS.CASH_UP_CONFIRM, CashUpConfirmModal);
vueApp.component(MODAL_NAMES__EPOS.CHANGE, ChangeModal);
vueApp.component(MODAL_NAMES__EPOS.SEARCH, SearchModal);
vueApp.component(MODAL_NAMES__EPOS.CLOVER_TERMINALS, CloverTerminalsModal);
vueApp.component(MODAL_NAMES__EPOS.COMPLETE_WAIVER, CompleteWaiverModal);
vueApp.component(MODAL_NAMES__EPOS.CUSTOMER_MARKETING_PREFERENCES, CustomerMarketingPreferencesModal);
vueApp.component(MODAL_NAMES__EPOS.CUSTOMER_DETAILS, CustomerDetailsModal);
vueApp.component(MODAL_NAMES__EPOS.DEBUG, DebugModal);
vueApp.component(MODAL_NAMES__EPOS.DOJO_TERMINALS, DojoTerminalsModal);
vueApp.component(MODAL_NAMES__EPOS.EPOS_MENU, EposMenuModal);
vueApp.component(MODAL_NAMES__EPOS.GIFT_AID, GiftAidModal);
vueApp.component(MODAL_NAMES__EPOS.GROUP_BOOKING_REFERENCE, GroupBookingReferenceModal);
vueApp.component(MODAL_NAMES__EPOS.HELD_CARTS, HeldCartsModal);
vueApp.component(MODAL_NAMES__EPOS.HOLD_CART, HoldCartModal);
vueApp.component(MODAL_NAMES__EPOS.KITCHEN_ORDERS, KitchenOrdersModal);
vueApp.component(MODAL_NAMES__EPOS.MANAGE_GOCARDLESS, ManageGoCardlessModal);
vueApp.component(MODAL_NAMES__EPOS.MEMBERS_CONFIRM, MembersConfirmModal);
vueApp.component(MODAL_NAMES__EPOS.MELLON_WEBECR_API_KEYS, MellonWebECRApiKeysModal);
vueApp.component(MODAL_NAMES__EPOS.MELLON_WEBECR_RECOVERY, MellonWebECRRecoveryModal);
vueApp.component(MODAL_NAMES__EPOS.MELLON_WEBECR_REDEEM, MellonWebECRRedeemModal);
vueApp.component(MODAL_NAMES__EPOS.MELLON_WEBECR_TRANSACTIONS, MellonWebECRTransactionsModal);
vueApp.component(MODAL_NAMES__EPOS.MEMBERSHIP_CANCELLATION, MembershipCancellationModal);
vueApp.component(MODAL_NAMES__EPOS.MEMBERSHIP_INSTALLMENTS, MembershipInstallmentsModal);
vueApp.component(MODAL_NAMES__EPOS.MEMBERSHIP_RENEWAL_DATE, MembershipRenewalDateModal);
vueApp.component(MODAL_NAMES__EPOS.MERGE_CART, MergeCartModal);
vueApp.component(MODAL_NAMES__EPOS.NEW_ORDER_WAIVERS, NewOrderWaiversModal);
vueApp.component(MODAL_NAMES__EPOS.ORDER_EMAIL_RECEIPT, OrderEmailReceiptModal);
vueApp.component(MODAL_NAMES__EPOS.ORDER_ERROR, OrderErrorModal);
vueApp.component(MODAL_NAMES__EPOS.ORDER_NOTES, OrderNotesModal);
vueApp.component(MODAL_NAMES__EPOS.ORDER_OUTSTANDING_BALANCE, OrderOutstandingBalanceModal);
vueApp.component(MODAL_NAMES__EPOS.ORDER_PAYMENT_DETAILS, OrderPaymentDetailsModal);
vueApp.component(MODAL_NAMES__EPOS.ORDER_PAYMENTS, OrderPaymentsModal);
vueApp.component(MODAL_NAMES__EPOS.ORDER_PREVIEW, OrderPreviewModal);
vueApp.component(MODAL_NAMES__EPOS.PARTIAL_PAYMENT, PartialPaymentModal);
vueApp.component(MODAL_NAMES__EPOS.PAYMENT_ERROR, PaymentErrorModal);
vueApp.component(MODAL_NAMES__EPOS.PAYMENT_TOKEN_SELECTION, PaymentTokenSelectionModal);
vueApp.component(MODAL_NAMES__EPOS.PAYYO_CONFIGURE_TIPS, PayyoConfigureTipsModal);
vueApp.component(MODAL_NAMES__EPOS.PAYYO_MANUAL_RECONCILIATION, PayyoManualReconciliationModal);
vueApp.component(MODAL_NAMES__EPOS.PAYYO_PAYMENT_DETAILS, PayyoPaymentDetailsModal);
vueApp.component(MODAL_NAMES__EPOS.PAYYO_TERMINALS, PayyoTerminalsModal);
vueApp.component(MODAL_NAMES__EPOS.PAYYO_TERMINAL_REGISTRATION, PayyoTerminalRegistrationModal);
vueApp.component(MODAL_NAMES__EPOS.PRICE_EDIT, PriceEditModal);
vueApp.component(MODAL_NAMES__EPOS.REFUNDABLE_PAYMENTS, RefundablePaymentsModal);
vueApp.component(MODAL_NAMES__EPOS.SEND_TO_KITCHEN, SendToKitchenModal);
vueApp.component(MODAL_NAMES__EPOS.SESSION_PICKER, SessionPickerModal);
vueApp.component(MODAL_NAMES__EPOS.SETTINGS, SettingsModal);
vueApp.component(MODAL_NAMES__EPOS.SIMULATE_PAYYO_PAYMENT, SimulatePayyoPaymentModal);
vueApp.component(MODAL_NAMES__EPOS.SOLD_GIFT_VOUCHER_DATA, SoldGiftVoucherDataModal);
vueApp.component(MODAL_NAMES__EPOS.SPLIT_PAYMENT, SplitPaymentModal);
vueApp.component(MODAL_NAMES__EPOS.TABLE_PICKER, TablePicker);
vueApp.component(MODAL_NAMES__EPOS.TICKET_PICKER, TicketPickerModal);
vueApp.component(MODAL_NAMES__EPOS.TODAY_VIEW_FILTERS, TodayViewFiltersModalSheet);
vueApp.component(MODAL_NAMES__EPOS.TRADING_SESSIONS_LIST, TradingSessionsListModal);
vueApp.component(MODAL_NAMES__EPOS.VARIABLE_DISCOUNT, VariableDiscountModal);
vueApp.component(MODAL_NAMES__EPOS.WAIVER_CODE, WaiverCodeModal);

// On EPOS the Vue router is not used for navigation yet - the Angular router is still used.
// It is used on some Vue pages to get URL params.
// If you are adding a new Vue page, see src/epos/vue/components/EposFullPageContainer.vue
const router = createRouter({
    history: createWebHashHistory(),
    routes: [],
});
vueApp.use(router);

// Mount the root component inside #vue-app-container (since Vue 3 it goes inside this element instead of replacing it.)
vueApp.mount('#vue-app-container');

// Make the Vue app and store available globally so non-Vue things can interact with them.
window.rootVueApp = vueApp;
window.rootVueStore = eposStore;
